


























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import html2canvas from "html2canvas";
import * as Hammer from "hammerjs";
import {
  Jubushese,
  Jubutaise,
  Hongdian,
  CalCuttedTongueArea,
} from "@/request/tongue";
import { dataUrlToBlob } from "@/utils/base64ToBlob";
import { UploadImage } from "@/request/tongue";
@Component({})
export default class IdrPicCanvas extends Vue {
  @Prop()
  private picSrc: any;
  @Prop()
  private tongue: any;
  @Prop()
  private picType: any;
  private cuttedArea: any = 0;
  private canvasWrap: any = {};
  private hammer: any = {};
  private sourceImage: any = {
    imgObj: {},
    x: 0,
    y: 0,
    sourceX: 0,
    sourceY: 0,
    centerX: 0,
    centerY: 0,
    width: 0,
    height: 0,
    originWidth: 0,
    originHeight: 0,
    rotateAngel: 0,
    moveX: 0,
    moveY: 0,
    scaleX: 1,
    scaleY: 1,
    aspectRadio: 1,
  };
  private canvas: any = {};
  private context: any = {};
  private model: any = "";
  private canvasCenterX: any = 0;
  private canvasCenterY: any = 0;
  // 操作值
  private startPoint: any = {};
  private endPoint: any = {};
  // 临时路径
  private tempPath: any[] = [];
  private sheseColor: string = "#E71D36";
  private taiseColor: string = "#FEC9C9";
  private hongdianColor: string = "#FF7473";
  private yubanColor: string = "#9055A2";
  private chihenColor: string = "#F6EA8C";
  private liewenColor: string = "#67D5B5";
  private kuankuanbiColor: string = "#82EC06";
  private kuankuanbiModel: string = "";
  private ifMouseLeftDown: boolean = false;
  private ifMouseRightDown: boolean = false;
  // private get ossClient() {
  //   return this.$store.state.ossClient;
  // }
  private get t() {
    return this.tongue;
  }
  private set t(val) {
    this.$emit("update:tongue", val);
  }
  private get canvasClientX() {
    return (this.$refs.canvasWrap as any).offsetLeft;
  }
  private get canvasClientY() {
    return (this.$refs.canvasWrap as any).offsetTop;
  }
  private getTransform() {
    return (
      "rotate(" +
      this.sourceImage.rotateAngel +
      "deg)" +
      " scale(" +
      this.sourceImage.scaleX +
      "," +
      this.sourceImage.scaleY +
      ")"
    );
  }
  @Watch("picSrc")
  private picSrcChange(src) {
    this.initCanvas();
  }
  private calCuttedTongueArea() {
    const params: any = {
      分割后舌图: this.tongue["舌象照片"]["分割后图片"],
    };
    CalCuttedTongueArea(this, params).then((data: any) => {
      this.cuttedArea = data["area"];
    });
  }
  /**
   * @description 初始化canvas和显示图片
   */
  private initCanvas() {
    this.canvasWrap = this.$refs.canvasWrap;
    this.canvas = this.$refs.canvas;
    this.canvas.width = this.canvasWrap.offsetWidth;
    this.canvas.height = this.canvasWrap.offsetHeight;
    this.context = this.canvas.getContext("2d");
    // 绘制黑色背景
    this.context.fillStyle = "black";
    this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.drawImgInInitCanvas();
    // this.hammer = new Hammer(this.canvasWrap);
    // this.hammer.get("pinch").set({ enable: true });
    // this.hammer.on("pinchin", (e) => {
    //   console.log(e);
    // });
  }
  /**
   * @description 初始化绘制图片到canvas里
   */
  private drawImgInInitCanvas() {
    const imageObj = new Image();
    imageObj.crossOrigin = "anonymous";
    imageObj.onload = (e: any) => {
      const img = e.path[0];
      this.sourceImage.imgObj = img;
      let dx: number = 0;
      let dy: number = 0;
      let dWidth: any = 0;
      let dHeight: any = 0;
      // 处理缩放
      this.sourceImage.originWidth = img.width;
      this.sourceImage.originHeight = img.height;
      const originAspectRatio: any = img.width / img.height;
      this.sourceImage.aspectRadio = originAspectRatio;
      if (img.width >= this.canvas.width) {
        dWidth = this.canvas.width;
        dHeight = Math.round(dWidth / originAspectRatio);
        if (dHeight >= this.canvas.height) {
          dHeight = this.canvas.height;
          dWidth = Math.round(dHeight * originAspectRatio);
        }
      } else {
        dHeight = this.canvas.height;
        dWidth = Math.round(dHeight * originAspectRatio);
        if (dWidth >= this.canvas.width) {
          dWidth = this.canvas.width;
          dHeight = Math.round(dWidth / originAspectRatio);
        }
      }
      // 记录底图宽高
      this.sourceImage.width = dWidth;
      this.sourceImage.height = dHeight;
      // 处理居中
      dx = (this.canvas.width - dWidth) / 2;
      dy = (this.canvas.height - dHeight) / 2;
      // 记录底图左上角原点位置
      this.sourceImage.sourceX = this.sourceImage.x = dx;
      this.sourceImage.sourceY = this.sourceImage.y = dy;
      // 记录底图中心点
      this.sourceImage.centerX = dx + dWidth / 2;
      this.sourceImage.centerY = dy + dHeight / 2;
      // 旋转角
      if (this.t["轨迹"]["旋转角"]) {
        this.sourceImage.rotateAngel = this.t["轨迹"]["旋转角"];
      }
      // 绘图
      this.context.drawImage(
        imageObj,
        this.sourceImage.x,
        this.sourceImage.y,
        dWidth,
        dHeight
      );
      this.drawPath();
    };
    imageObj.src = this.picSrc + "?t=" + new Date().getTime();
  }
  /**
   * @description 处理鼠标按下
   */
  private handleMouseDown(e) {
    // console.log("mousedown", e.button);
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (this.model !== "放大镜") {
      if (e.button === 0) {
        this.ifMouseLeftDown = true;
      } else {
        return;
      }
    } else {
      if (e.button === 0) {
        this.ifMouseLeftDown = true;
      } else if (e.button === 2) {
        this.ifMouseRightDown = true;
      } else {
        return;
      }
    }
    this.startPoint = { offsetX: e.offsetX, offsetY: e.offsetY };
    switch (this.model) {
      case "局部舌色":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.sheseColor;
        this.tempPath = [];
        break;
      case "局部苔色":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.taiseColor;
        this.tempPath = [];
        break;
      case "舌上红点":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.hongdianColor;
        this.tempPath = [];
        break;
      case "瘀斑":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.yubanColor;
        this.tempPath = [];
        break;
      case "齿痕":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.chihenColor;
        this.tempPath = [];
        break;
      case "裂纹":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.liewenColor;
        this.tempPath = [];
        break;
      case "宽宽比":
        if (
          this.t["舌形特征标注"]["胖瘦参数"]["舌间距"] &&
          this.t["舌形特征标注"]["胖瘦参数"]["嘴角间距"]
        ) {
          this.$message.error("嘴角间距和舌间距都已存在，请删除后重新绘制");
          this.model = "";
          this.$emit("modelChange", "");
          this.startPoint = {};
          return;
        }
        if (!this.t["舌形特征标注"]["胖瘦参数"]["嘴角间距"]) {
          this.kuankuanbiModel = "嘴角间距";
        } else {
          this.kuankuanbiModel = "舌间距";
        }
        this.context.save();
        this.context.strokeStyle = this.kuankuanbiColor;
        this.endPoint = {};
        break;
      case "放大镜":
        if (this.ifMouseLeftDown === true) {
          if (this.ifMouseRightDown) {
            // if (!this.ossClient["options"]) {
            //   return;
            // }
            if (this.tongue["局部舌苔放大图"].length >= 3) {
              this.$message.warning(
                "对不起，您保存的舌苔放大图已经超过3张了，如需保存，请先删除当前保存的图片"
              );
              return;
            }
            const c = document.createElement("canvas");
            c.width = 100;
            c.height = 100;
            const cxt: any = c.getContext("2d");
            this.drawBlackBack().then(() => {
              this.draw();
              const originImgData = this.context.getImageData(
                e.offsetX - 50,
                e.offsetY - 50,
                100,
                100
              );
              cxt.putImageData(originImgData, 0, 0);
              const dataurl = c.toDataURL();
              const blobData = dataUrlToBlob(dataurl);
              const fileName = new Date().getTime().toString();
              const uploadFilePath: any = "ds/tongue/" + fileName + ".png";
              try {
                // this.ossClient.put(uploadFilePath, blobData).then((result) => {
                //   this.$emit("jubushetai", result["url"]);
                // });
                const params: any = {
                  type: "tongue",
                  base64_image: dataurl,
                };
                console.log(params);
                UploadImage(this, params).then((data: any) => {
                  this.$emit("jubushetai", data["image_url"]);
                });
              } catch (e) {
                console.log(e);
              }
            });
          } else {
            this.draw();
            this.context.save();
            this.context.drawImage(
              this.sourceImage.imgObj,
              (e.offsetX -
                50 -
                (this.canvas.width - this.sourceImage.width) / 2) /
                (this.sourceImage.width / this.sourceImage.originWidth),
              (e.offsetY -
                50 -
                (this.canvas.height - this.sourceImage.height) / 2) /
                (this.sourceImage.height / this.sourceImage.originHeight),
              100 / (this.sourceImage.width / this.sourceImage.originWidth),
              100 / (this.sourceImage.height / this.sourceImage.originHeight),
              e.offsetX - 100,
              e.offsetY - 100,
              200,
              200
            );
            this.context.restore();
          }
        }
        break;
    }
  }
  /**
   * @description 处理鼠标移动
   */
  private handleMouseMove(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (!this.startPoint.offsetX || !this.model) {
      return;
    }
    if (this.ifMouseLeftDown) {
      this.drawBlackBack().then(() => {
        const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
        const blackHeight = (this.canvas.height - this.sourceImage.height) / 2;
        switch (this.model) {
          case "局部舌色":
            this.draw();
            this.context.lineTo(e.offsetX, e.offsetY);
            this.tempPath.push({
              offsetX: e.offsetX - blackWidth,
              offsetY: e.offsetY - blackHeight,
            });
            this.context.stroke();
            break;
          case "局部苔色":
            this.draw();
            this.context.lineTo(e.offsetX, e.offsetY);
            this.tempPath.push({
              offsetX: e.offsetX - blackWidth,
              offsetY: e.offsetY - blackHeight,
            });
            this.context.stroke();
            break;
          case "舌上红点":
            this.draw();
            this.context.lineTo(e.offsetX, e.offsetY);
            this.tempPath.push({
              offsetX: e.offsetX - blackWidth,
              offsetY: e.offsetY - blackHeight,
            });
            this.context.stroke();
            break;
          case "瘀斑":
            this.draw();
            this.context.lineTo(e.offsetX, e.offsetY);
            this.tempPath.push({
              offsetX: e.offsetX - blackWidth,
              offsetY: e.offsetY - blackHeight,
            });
            this.context.stroke();
            break;
          case "齿痕":
            this.draw();
            this.context.lineTo(e.offsetX, e.offsetY);
            this.tempPath.push({
              offsetX: e.offsetX - blackWidth,
              offsetY: e.offsetY - blackHeight,
            });
            this.context.stroke();
            break;
          case "裂纹":
            this.draw();
            this.context.lineTo(e.offsetX, e.offsetY);
            this.tempPath.push({
              offsetX: e.offsetX - blackWidth,
              offsetY: e.offsetY - blackHeight,
            });
            this.context.stroke();
            break;
          case "宽宽比":
            this.draw();
            this.context.beginPath();
            this.context.moveTo(
              this.startPoint.offsetX,
              this.startPoint.offsetY
            );
            this.context.lineTo(e.offsetX, e.offsetY);
            this.context.stroke();
            this.context.closePath();
            this.endPoint = {
              offsetX: e.offsetX,
              offsetY: e.offsetY,
            };
            break;
          case "移动":
            this.sourceImage.moveX += e.movementX;
            this.sourceImage.moveY += e.movementY;
            this.draw();
            this.drawPath();
            break;
          case "缩放":
            const bigSpeed = 1.01;
            const smallSpeed = 0.99;
            let targetX;
            // let targetY;
            if (e.movementX > 0) {
              this.sourceImage.scaleX *= bigSpeed;
              targetX = bigSpeed;
            } else {
              this.sourceImage.scaleX *= smallSpeed;
              targetX = smallSpeed;
            }
            this.sourceImage.scaleY = this.sourceImage.scaleX;
            this.draw();
            this.drawPath();
            break;
          case "放大镜":
            this.draw();
            this.context.save();
            this.context.drawImage(
              this.sourceImage.imgObj,
              (e.offsetX -
                50 -
                (this.canvas.width - this.sourceImage.width) / 2) /
                (this.sourceImage.width / this.sourceImage.originWidth),
              (e.offsetY -
                50 -
                (this.canvas.height - this.sourceImage.height) / 2) /
                (this.sourceImage.height / this.sourceImage.originHeight),
              100 / (this.sourceImage.width / this.sourceImage.originWidth),
              100 / (this.sourceImage.height / this.sourceImage.originHeight),
              e.offsetX - 100,
              e.offsetY - 100,
              200,
              200
            );
            this.context.restore();
            break;
          case "旋转":
            let rotateAngel = Math.PI / (6 * 1);
            if (e.movementY < 0) {
              rotateAngel = -rotateAngel;
            } else if (e.movementY === 0) {
              rotateAngel = 0;
            }
            this.sourceImage.rotateAngel += rotateAngel;
            this.t["轨迹"]["旋转角"] = this.sourceImage.rotateAngel;
            this.draw();
            this.drawPath();
            break;
          default:
            this.draw();
            this.drawPath();
        }
      });
    }
    // console.log('mousemove',e);
  }
  /**
   * @description 处理鼠标弹起
   */
  private handleMouseUp(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    // console.log("mouseup", e);
    if (this.ifMouseLeftDown) {
      const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
      const blackHeight = (this.canvas.height - this.sourceImage.height) / 2;
      switch (this.model) {
        case "局部舌色":
          this.context.closePath();
          if (this.picType === "origin") {
            const tempStartPoint = _.cloneDeep(this.startPoint);
            tempStartPoint.offsetX -= blackWidth;
            tempStartPoint.offsetY -= blackHeight;
            this.context.save();
            this.drawBlackBack().then(async () => {
              this.context.clip();
              this.draw();
              const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
                "image/jpeg",
                1.0
              );
              const params: any = {
                局部舌图: imgData,
              };
              const data = await Jubushese(this, params);
              this.t["局部舌色特征标注"] = data;
              this.t["轨迹"]["局部舌色"] = {
                startPoint: {
                  offsetX: tempStartPoint.offsetX,
                  offsetY: tempStartPoint.offsetY,
                },
                path: this.tempPath,
                width: this.sourceImage.width,
                height: this.sourceImage.height,
              };
              this.tempPath = [];
              this.startPoint = {};
              this.context.restore();
              this.draw();
              this.drawPath();
            });
          } else {
            this.context.closePath();
            this.context.stroke();
            this.tempPath = [];
            this.startPoint = {};
          }
          this.context.restore();
          break;
        case "局部苔色":
          this.context.closePath();
          if (this.picType === "origin") {
            const tempStartPoint = _.cloneDeep(this.startPoint);
            tempStartPoint.offsetX -= blackWidth;
            tempStartPoint.offsetY -= blackHeight;
            this.context.save();
            this.drawBlackBack().then(async () => {
              this.context.clip();
              this.draw();
              const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
                "image/jpeg",
                1.0
              );
              const params: any = {
                局部苔图: imgData,
              };
              const data = await Jubutaise(this, params);
              this.t["局部苔色特征标注"] = data;
              this.t["轨迹"]["局部苔色"] = {
                startPoint: {
                  offsetX: tempStartPoint.offsetX,
                  offsetY: tempStartPoint.offsetY,
                },
                path: this.tempPath,
                width: this.sourceImage.width,
                height: this.sourceImage.height,
              };
              this.tempPath = [];
              this.startPoint = {};
              this.context.restore();
              this.draw();
              this.drawPath();
            });
          } else {
            this.context.closePath();
            this.context.stroke();
            this.tempPath = [];
            this.startPoint = {};
          }
          this.context.restore();
          break;
        case "舌上红点":
          this.context.closePath();
          if (this.picType === "origin") {
            const tempStartPoint = _.cloneDeep(this.startPoint);
            tempStartPoint.offsetX -= blackWidth;
            tempStartPoint.offsetY -= blackHeight;
            this.context.save();
            this.drawBlackBack().then(async () => {
              this.context.clip();
              this.draw();
              // 计算当前绘图面积
              const area = this.calDrawedArea();
              // 发送数据
              const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
                "image/jpeg",
                1.0
              );
              const params: any = {
                舌上红点图: imgData,
              };
              const data = await Hongdian(this, params);
              data["is_labeled"] = true;
              this.t["舌形特征标注"]["舌上红点参数"] = data;
              this.t["舌形特征标注"]["舌上红点参数"]["红点区域"] = area + "%";
              this.t["轨迹"]["舌上红点"] = {
                startPoint: {
                  offsetX: tempStartPoint.offsetX,
                  offsetY: tempStartPoint.offsetY,
                },
                path: this.tempPath,
                width: this.sourceImage.width,
                height: this.sourceImage.height,
              };
              this.tempPath = [];
              this.startPoint = {};
              this.context.restore();
              this.draw();
              this.drawPath();
            });
          } else {
            this.context.closePath();
            this.context.stroke();
            this.tempPath = [];
            this.startPoint = {};
          }
          this.context.restore();
          break;
        case "瘀斑":
          this.context.closePath();
          if (this.picType === "origin") {
            const tempStartPoint = _.cloneDeep(this.startPoint);
            tempStartPoint.offsetX -= blackWidth;
            tempStartPoint.offsetY -= blackHeight;
            this.context.save();
            this.drawBlackBack().then(async () => {
              this.context.clip();
              this.draw();
              const area = this.calDrawedArea();
              const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
                "image/jpeg",
                1.0
              );
              if (!Array.isArray(this.t["轨迹"]["瘀斑"])) {
                this.t["轨迹"]["瘀斑"] = [];
              }
              this.t["轨迹"]["瘀斑"].push({
                startPoint: {
                  offsetX: tempStartPoint.offsetX,
                  offsetY: tempStartPoint.offsetY,
                },
                path: this.tempPath,
                width: this.sourceImage.width,
                height: this.sourceImage.height,
                area: (Number(area) / 100) * this.cuttedArea,
              });
              const arr: any[] = [];
              let totalArea: any = 0;
              this.t["轨迹"]["瘀斑"].forEach((item: any) => {
                arr.push({
                  area: item["area"].toFixed(4) + "px²",
                });
                totalArea += item["area"];
              });
              const d: any = {
                is_labeled: true,
                瘀斑面积占比: (totalArea / this.cuttedArea).toFixed(4),
                瘀斑数量: arr.length,
                瘀斑: arr,
              };
              this.t["舌形特征标注"]["瘀斑参数"] = d;
              this.tempPath = [];
              this.startPoint = {};
              this.context.restore();
              this.draw();
              this.drawPath();
            });
          } else {
            this.context.closePath();
            this.context.stroke();
            this.tempPath = [];
            this.startPoint = {};
          }
          this.context.restore();
          break;
        case "齿痕":
          this.context.closePath();
          if (this.picType === "origin") {
            const tempStartPoint = _.cloneDeep(this.startPoint);
            tempStartPoint.offsetX -= blackWidth;
            tempStartPoint.offsetY -= blackHeight;
            this.context.save();
            this.drawBlackBack().then(async () => {
              this.context.clip();
              this.draw();
              const area = this.calDrawedArea();
              const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
                "image/jpeg",
                1.0
              );
              if (!Array.isArray(this.t["轨迹"]["齿痕"])) {
                this.t["轨迹"]["齿痕"] = [];
              }
              this.t["轨迹"]["齿痕"].push({
                startPoint: {
                  offsetX: tempStartPoint.offsetX,
                  offsetY: tempStartPoint.offsetY,
                },
                path: this.tempPath,
                width: this.sourceImage.width,
                height: this.sourceImage.height,
                area: (Number(area) / 100) * this.cuttedArea,
              });
              const arr: any[] = [];
              let totalArea: any = 0;
              this.t["轨迹"]["齿痕"].forEach((item: any) => {
                arr.push({
                  area: item["area"].toFixed(4) + "px²",
                });
                totalArea += item["area"];
              });
              const d: any = {
                is_labeled: true,
                齿痕面积占比: (totalArea / this.cuttedArea).toFixed(4),
                齿痕数量: arr.length,
                齿痕: arr,
              };
              this.t["舌形特征标注"]["齿痕参数"] = d;
              this.tempPath = [];
              this.startPoint = {};
              this.context.restore();
              this.draw();
              this.drawPath();
            });
          } else {
            this.context.closePath();
            this.context.stroke();
            this.tempPath = [];
            this.startPoint = {};
          }
          this.context.restore();
          break;
        case "裂纹":
          // this.context.closePath();
          if (this.picType === "origin") {
            const tempStartPoint = _.cloneDeep(this.startPoint);
            tempStartPoint.offsetX -= blackWidth;
            tempStartPoint.offsetY -= blackHeight;
            this.context.save();
            this.drawBlackBack().then(async () => {
              // this.context.clip();
              // this.draw();
              // const area = this.calDrawedArea();
              // const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
              //   "image/jpeg",
              //   1.0
              // );
              if (!Array.isArray(this.t["轨迹"]["裂纹"])) {
                this.t["轨迹"]["裂纹"] = [];
              }
              this.t["轨迹"]["裂纹"].push({
                startPoint: {
                  offsetX: tempStartPoint.offsetX,
                  offsetY: tempStartPoint.offsetY,
                },
                path: this.tempPath,
                width: this.sourceImage.width,
                height: this.sourceImage.height,
                length: this.tempPath.length,
              });
              const arr: any[] = [];
              let totalLength: any = 0;
              this.t["轨迹"]["裂纹"].forEach((item: any) => {
                arr.push({
                  length: item["length"] + "px",
                });
                totalLength += item["length"];
              });
              const d: any = {
                is_labeled: true,
                裂纹总长度: totalLength,
                裂纹数量: arr.length,
                裂纹: arr,
              };
              this.t["舌形特征标注"]["裂纹参数"] = d;
              this.tempPath = [];
              this.startPoint = {};
              this.context.restore();
              this.draw();
              this.drawPath();
            });
          } else {
            // this.context.closePath();
            // this.context.stroke();
            this.tempPath = [];
            this.startPoint = {};
          }
          this.context.restore();
          break;
        case "宽宽比":
          if (this.picType === "origin") {
            const tempStartPoint = _.cloneDeep(this.startPoint);
            tempStartPoint.offsetX -= blackWidth;
            tempStartPoint.offsetY -= blackHeight;
            const tempEndPoint = _.cloneDeep(this.endPoint);
            tempEndPoint.offsetX -= blackWidth;
            tempEndPoint.offsetY -= blackHeight;
            this.t["轨迹"]["宽宽比"][this.kuankuanbiModel] = {
              startPoint: tempStartPoint,
              endPoint: tempEndPoint,
              width: this.sourceImage.width,
              height: this.sourceImage.height,
            };
            this.t["舌形特征标注"]["胖瘦参数"][
              this.kuankuanbiModel
            ] = this.calLineLength(tempStartPoint, tempEndPoint);
            this.t["舌形特征标注"]["胖瘦参数"]["is_labeled"] = true;
            this.startPoint = {};
            this.endPoint = {};
            this.drawPath();
            if (
              this.t["舌形特征标注"]["胖瘦参数"]["嘴角间距"] &&
              this.t["舌形特征标注"]["胖瘦参数"]["舌间距"]
            ) {
              this.t["舌形特征标注"]["胖瘦参数"]["宽宽比"] =
                this.t["舌形特征标注"]["胖瘦参数"]["嘴角间距"] /
                this.t["舌形特征标注"]["胖瘦参数"]["舌间距"];
              this.model = "";
              this.$emit("modelChange", "");
            }
          }

          break;
        case "放大镜":
          this.drawBlackBack().then(() => {
            this.draw();
            this.drawPath();
          });

          break;
      }
      this.startPoint.offsetX = 0;
      this.startPoint.offsetY = 0;
      this.ifMouseLeftDown = false;
    }
    if (this.ifMouseRightDown) {
      this.ifMouseRightDown = false;
    }
  }
  /**
   * @description 处理鼠标右键弹出菜单
   */
  private handleContextMenu(e) {
    if (this.model === "放大镜") {
      e.preventDefault();
    }
  }
  /**
   * @description 处理手指按下
   */
  private handleTouchStart(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    // alert(e.touches[0].clientX);
    // if (this.model !== "放大镜") {
    //   if (e.button === 0) {
    //     this.ifMouseLeftDown = true;
    //   } else {
    //     return;
    //   }
    // } else {
    //   if (e.button === 0) {
    //     this.ifMouseLeftDown = true;
    //   } else if (e.button === 2) {
    //     this.ifMouseRightDown = true;
    //   } else {
    //     return;
    //   }
    // }

    this.startPoint = {
      offsetX: e.touches[0].clientX - this.canvasClientX,
      offsetY: e.touches[0].clientY - this.canvasClientY,
    };
    switch (this.model) {
      case "局部舌色":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.sheseColor;
        this.tempPath = [];
        break;
      case "局部苔色":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.taiseColor;
        this.tempPath = [];
        break;
      case "舌上红点":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.hongdianColor;
        this.tempPath = [];
        break;
      case "瘀斑":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.yubanColor;
        this.tempPath = [];
        break;
      case "齿痕":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.chihenColor;
        this.tempPath = [];
        break;
      case "裂纹":
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
        this.context.strokeStyle = this.liewenColor;
        this.tempPath = [];
        break;
      case "宽宽比":
        if (
          this.t["舌形特征标注"]["胖瘦参数"]["舌间距"] &&
          this.t["舌形特征标注"]["胖瘦参数"]["嘴角间距"]
        ) {
          this.$message.error("嘴角间距和舌间距都已存在，请删除后重新绘制");
          this.model = "";
          this.$emit("modelChange", "");
          this.startPoint = {};
          return;
        }
        if (!this.t["舌形特征标注"]["胖瘦参数"]["嘴角间距"]) {
          this.kuankuanbiModel = "嘴角间距";
        } else {
          this.kuankuanbiModel = "舌间距";
        }
        this.context.save();
        this.context.strokeStyle = this.kuankuanbiColor;
        this.endPoint = {};
        break;
      case "放大镜":
        if (this.ifMouseLeftDown === true) {
          if (this.ifMouseRightDown) {
            // if (!this.ossClient["options"]) {
            //   return;
            // }
            if (this.tongue["局部舌苔放大图"].length >= 3) {
              this.$message.warning(
                "对不起，您保存的舌苔放大图已经超过3张了，如需保存，请先删除当前保存的图片"
              );
              return;
            }
            const c = document.createElement("canvas");
            c.width = 100;
            c.height = 100;
            const cxt: any = c.getContext("2d");
            this.drawBlackBack().then(() => {
              this.draw();
              const originImgData = this.context.getImageData(
                e.touches[0].clientX - this.canvasClientX - 50,
                e.touches[0].clientY - this.canvasClientY - 50,
                100,
                100
              );
              cxt.putImageData(originImgData, 0, 0);
              const dataurl = c.toDataURL();
              const blobData = dataUrlToBlob(dataurl);
              const fileName = new Date().getTime().toString();
              const uploadFilePath: any = "ds/tongue/" + fileName + ".png";
              try {
                // this.ossClient.put(uploadFilePath, blobData).then((result) => {
                //   this.$emit("jubushetai", result["url"]);
                // });
                const params: any = {
                  type: "tongue",
                  base64_image: dataurl,
                };
                console.log(params);
                UploadImage(this, params).then((data: any) => {
                  this.$emit("jubushetai", data["image_url"]);
                });
              } catch (e) {
                console.log(e);
              }
            });
          } else {
            this.draw();
            this.context.save();
            this.context.drawImage(
              this.sourceImage.imgObj,
              (e.offsetX -
                50 -
                (this.canvas.width - this.sourceImage.width) / 2) /
                (this.sourceImage.width / this.sourceImage.originWidth),
              (e.offsetY -
                50 -
                (this.canvas.height - this.sourceImage.height) / 2) /
                (this.sourceImage.height / this.sourceImage.originHeight),
              100 / (this.sourceImage.width / this.sourceImage.originWidth),
              100 / (this.sourceImage.height / this.sourceImage.originHeight),
              e.offsetX - 100,
              e.offsetY - 100,
              200,
              200
            );
            this.context.restore();
          }
        }
        break;
    }
  }
  /**
   * @description 处理手指移动
   */
  private handleTouchMove(e) {
    const movementX = e.touches[0].clientX - this.startPoint.offsetX;
    const movementY = e.touches[0].clientY - this.startPoint.offsetY;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (!this.startPoint.offsetX || !this.model) {
      return;
    }
    this.drawBlackBack().then(() => {
      const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
      const blackHeight = (this.canvas.height - this.sourceImage.height) / 2;
      switch (this.model) {
        case "局部舌色":
          this.draw();
          this.context.lineTo(
            e.touches[0].clientX - this.canvasClientX,
            e.touches[0].clientY - this.canvasClientY
          );
          this.tempPath.push({
            offsetX: e.touches[0].clientX - this.canvasClientX - blackWidth,
            offsetY: e.touches[0].clientY - this.canvasClientY - blackHeight,
          });
          this.context.stroke();
          break;
        case "局部苔色":
          this.draw();
          this.context.lineTo(
            e.touches[0].clientX - this.canvasClientX,
            e.touches[0].clientY - this.canvasClientY
          );
          this.tempPath.push({
            offsetX: e.touches[0].clientX - this.canvasClientX - blackWidth,
            offsetY: e.touches[0].clientY - this.canvasClientY - blackHeight,
          });
          this.context.stroke();
          break;
        case "舌上红点":
          this.draw();
          this.context.lineTo(
            e.touches[0].clientX - this.canvasClientX,
            e.touches[0].clientY - this.canvasClientY
          );
          this.tempPath.push({
            offsetX: e.touches[0].clientX - this.canvasClientX - blackWidth,
            offsetY: e.touches[0].clientY - this.canvasClientY - blackHeight,
          });
          this.context.stroke();
          break;
        case "瘀斑":
          this.draw();
          this.context.lineTo(
            e.touches[0].clientX - this.canvasClientX,
            e.touches[0].clientY - this.canvasClientY
          );
          this.tempPath.push({
            offsetX: e.touches[0].clientX - this.canvasClientX - blackWidth,
            offsetY: e.touches[0].clientY - this.canvasClientY - blackHeight,
          });
          this.context.stroke();
          break;
        case "齿痕":
          this.draw();
          this.context.lineTo(
            e.touches[0].clientX - this.canvasClientX,
            e.touches[0].clientY - this.canvasClientY
          );
          this.tempPath.push({
            offsetX: e.touches[0].clientX - this.canvasClientX - blackWidth,
            offsetY: e.touches[0].clientY - this.canvasClientY - blackHeight,
          });
          this.context.stroke();
          break;
        case "裂纹":
          this.draw();
          this.context.lineTo(
            e.touches[0].clientX - this.canvasClientX,
            e.touches[0].clientY - this.canvasClientY
          );
          this.tempPath.push({
            offsetX: e.touches[0].clientX - this.canvasClientX - blackWidth,
            offsetY: e.touches[0].clientY - this.canvasClientY - blackHeight,
          });
          this.context.stroke();
          break;
        case "宽宽比":
          this.draw();
          this.context.beginPath();
          this.context.moveTo(this.startPoint.offsetX, this.startPoint.offsetY);
          this.context.lineTo(
            e.touches[0].clientX - this.canvasClientX,
            e.touches[0].clientY - this.canvasClientY
          );
          this.context.stroke();
          this.context.closePath();
          this.endPoint = {
            offsetX: e.touches[0].clientX - this.canvasClientX,
            offsetY: e.touches[0].clientY - this.canvasClientY,
          };
          break;
        case "移动":
          // this.sourceImage.moveX += e.movementX;
          // this.sourceImage.moveY += e.movementY;
          this.sourceImage.moveX = movementX;
          this.sourceImage.moveY = movementY;
          this.draw();
          this.drawPath();
          break;
        case "缩放":
          const bigSpeed = 1.01;
          const smallSpeed = 0.99;
          let targetX;
          // let targetY;
          if (
            e.touches[0].clientY - this.canvasClientY >
            this.startPoint.offsetY
          ) {
            this.sourceImage.scaleX *= bigSpeed;
            targetX = bigSpeed;
          } else {
            this.sourceImage.scaleX *= smallSpeed;
            targetX = smallSpeed;
          }
          this.sourceImage.scaleY = this.sourceImage.scaleX;
          this.draw();
          this.drawPath();
          break;
        case "放大镜":
          this.draw();
          this.context.save();
          this.context.drawImage(
            this.sourceImage.imgObj,
            (e.touches[0].clientX -
              this.canvasClientX -
              50 -
              (this.canvas.width - this.sourceImage.width) / 2) /
              (this.sourceImage.width / this.sourceImage.originWidth),
            (e.touches[0].clientY -
              this.canvasClientY -
              50 -
              (this.canvas.height - this.sourceImage.height) / 2) /
              (this.sourceImage.height / this.sourceImage.originHeight),
            100 / (this.sourceImage.width / this.sourceImage.originWidth),
            100 / (this.sourceImage.height / this.sourceImage.originHeight),
            e.touches[0].clientX - this.canvasClientX - 100,
            e.touches[0].clientY - this.canvasClientY - 100,
            200,
            200
          );
          this.context.restore();
          break;
        case "旋转":
          let rotateAngel = Math.PI / (6 * 1);
          if (movementY < 0) {
            rotateAngel = -rotateAngel;
          } else if (movementY === 0) {
            rotateAngel = 0;
          }
          this.sourceImage.rotateAngel += rotateAngel;
          this.t["轨迹"]["旋转角"] = this.sourceImage.rotateAngel;
          this.draw();
          this.drawPath();
          break;
        default:
          this.draw();
          this.drawPath();
      }
    });
    // console.log('mousemove',e);
  }
  /**
   * @description 处理手指弹起
   */
  private handleTouchEnd(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    // console.log("mouseup", e);
    const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
    const blackHeight = (this.canvas.height - this.sourceImage.height) / 2;
    switch (this.model) {
      case "局部舌色":
        this.context.closePath();
        if (this.picType === "origin") {
          const tempStartPoint = _.cloneDeep(this.startPoint);
          tempStartPoint.offsetX -= blackWidth;
          tempStartPoint.offsetY -= blackHeight;
          this.context.save();
          this.drawBlackBack().then(async () => {
            this.context.clip();
            this.draw();
            const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
              "image/jpeg",
              1.0
            );
            const params: any = {
              局部舌图: imgData,
            };
            const data = await Jubushese(this, params);
            this.t["局部舌色特征标注"] = data;
            this.t["轨迹"]["局部舌色"] = {
              startPoint: {
                offsetX: tempStartPoint.offsetX,
                offsetY: tempStartPoint.offsetY,
              },
              path: this.tempPath,
              width: this.sourceImage.width,
              height: this.sourceImage.height,
            };
            this.tempPath = [];
            this.startPoint = {};
            this.context.restore();
            this.draw();
            this.drawPath();
          });
        } else {
          this.context.closePath();
          this.context.stroke();
          this.tempPath = [];
          this.startPoint = {};
        }
        this.context.restore();
        break;
      case "局部苔色":
        this.context.closePath();
        if (this.picType === "origin") {
          const tempStartPoint = _.cloneDeep(this.startPoint);
          tempStartPoint.offsetX -= blackWidth;
          tempStartPoint.offsetY -= blackHeight;
          this.context.save();
          this.drawBlackBack().then(async () => {
            this.context.clip();
            this.draw();
            const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
              "image/jpeg",
              1.0
            );
            const params: any = {
              局部苔图: imgData,
            };
            const data = await Jubutaise(this, params);
            this.t["局部苔色特征标注"] = data;
            this.t["轨迹"]["局部苔色"] = {
              startPoint: {
                offsetX: tempStartPoint.offsetX,
                offsetY: tempStartPoint.offsetY,
              },
              path: this.tempPath,
              width: this.sourceImage.width,
              height: this.sourceImage.height,
            };
            this.tempPath = [];
            this.startPoint = {};
            this.context.restore();
            this.draw();
            this.drawPath();
          });
        } else {
          this.context.closePath();
          this.context.stroke();
          this.tempPath = [];
          this.startPoint = {};
        }
        this.context.restore();
        break;
      case "舌上红点":
        this.context.closePath();
        if (this.picType === "origin") {
          const tempStartPoint = _.cloneDeep(this.startPoint);
          tempStartPoint.offsetX -= blackWidth;
          tempStartPoint.offsetY -= blackHeight;
          this.context.save();
          this.drawBlackBack().then(async () => {
            this.context.clip();
            this.draw();
            // 计算当前绘图面积
            const area = this.calDrawedArea();
            // 发送数据
            const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
              "image/jpeg",
              1.0
            );
            const params: any = {
              舌上红点图: imgData,
            };
            const data = await Hongdian(this, params);
            data["is_labeled"] = true;
            this.t["舌形特征标注"]["舌上红点参数"] = data;
            this.t["舌形特征标注"]["舌上红点参数"]["红点区域"] = area + "%";
            this.t["轨迹"]["舌上红点"] = {
              startPoint: {
                offsetX: tempStartPoint.offsetX,
                offsetY: tempStartPoint.offsetY,
              },
              path: this.tempPath,
              width: this.sourceImage.width,
              height: this.sourceImage.height,
            };
            this.tempPath = [];
            this.startPoint = {};
            this.context.restore();
            this.draw();
            this.drawPath();
          });
        } else {
          this.context.closePath();
          this.context.stroke();
          this.tempPath = [];
          this.startPoint = {};
        }
        this.context.restore();
        break;
      case "瘀斑":
        this.context.closePath();
        if (this.picType === "origin") {
          const tempStartPoint = _.cloneDeep(this.startPoint);
          tempStartPoint.offsetX -= blackWidth;
          tempStartPoint.offsetY -= blackHeight;
          this.context.save();
          this.drawBlackBack().then(async () => {
            this.context.clip();
            this.draw();
            const area = this.calDrawedArea();
            const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
              "image/jpeg",
              1.0
            );
            if (!Array.isArray(this.t["轨迹"]["瘀斑"])) {
              this.t["轨迹"]["瘀斑"] = [];
            }
            this.t["轨迹"]["瘀斑"].push({
              startPoint: {
                offsetX: tempStartPoint.offsetX,
                offsetY: tempStartPoint.offsetY,
              },
              path: this.tempPath,
              width: this.sourceImage.width,
              height: this.sourceImage.height,
              area: (Number(area) / 100) * this.cuttedArea,
            });
            const arr: any[] = [];
            let totalArea: any = 0;
            this.t["轨迹"]["瘀斑"].forEach((item: any) => {
              arr.push({
                area: item["area"].toFixed(4) + "px²",
              });
              totalArea += item["area"];
            });
            const d: any = {
              is_labeled: true,
              瘀斑面积占比: (totalArea / this.cuttedArea).toFixed(4),
              瘀斑数量: arr.length,
              瘀斑: arr,
            };
            this.t["舌形特征标注"]["瘀斑参数"] = d;
            this.tempPath = [];
            this.startPoint = {};
            this.context.restore();
            this.draw();
            this.drawPath();
          });
        } else {
          this.context.closePath();
          this.context.stroke();
          this.tempPath = [];
          this.startPoint = {};
        }
        this.context.restore();
        break;
      case "齿痕":
        this.context.closePath();
        if (this.picType === "origin") {
          const tempStartPoint = _.cloneDeep(this.startPoint);
          tempStartPoint.offsetX -= blackWidth;
          tempStartPoint.offsetY -= blackHeight;
          this.context.save();
          this.drawBlackBack().then(async () => {
            this.context.clip();
            this.draw();
            const area = this.calDrawedArea();
            const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
              "image/jpeg",
              1.0
            );
            if (!Array.isArray(this.t["轨迹"]["齿痕"])) {
              this.t["轨迹"]["齿痕"] = [];
            }
            this.t["轨迹"]["齿痕"].push({
              startPoint: {
                offsetX: tempStartPoint.offsetX,
                offsetY: tempStartPoint.offsetY,
              },
              path: this.tempPath,
              width: this.sourceImage.width,
              height: this.sourceImage.height,
              area: (Number(area) / 100) * this.cuttedArea,
            });
            const arr: any[] = [];
            let totalArea: any = 0;
            this.t["轨迹"]["齿痕"].forEach((item: any) => {
              arr.push({
                area: item["area"].toFixed(4) + "px²",
              });
              totalArea += item["area"];
            });
            const d: any = {
              is_labeled: true,
              齿痕面积占比: (totalArea / this.cuttedArea).toFixed(4),
              齿痕数量: arr.length,
              齿痕: arr,
            };
            this.t["舌形特征标注"]["齿痕参数"] = d;
            this.tempPath = [];
            this.startPoint = {};
            this.context.restore();
            this.draw();
            this.drawPath();
          });
        } else {
          this.context.closePath();
          this.context.stroke();
          this.tempPath = [];
          this.startPoint = {};
        }
        this.context.restore();
        break;
      case "裂纹":
        // this.context.closePath();
        if (this.picType === "origin") {
          const tempStartPoint = _.cloneDeep(this.startPoint);
          tempStartPoint.offsetX -= blackWidth;
          tempStartPoint.offsetY -= blackHeight;
          this.context.save();
          this.drawBlackBack().then(async () => {
            // this.context.clip();
            // this.draw();
            // const area = this.calDrawedArea();
            // const imgData = (this.canvas as HTMLCanvasElement).toDataURL(
            //   "image/jpeg",
            //   1.0
            // );
            if (!Array.isArray(this.t["轨迹"]["裂纹"])) {
              this.t["轨迹"]["裂纹"] = [];
            }
            this.t["轨迹"]["裂纹"].push({
              startPoint: {
                offsetX: tempStartPoint.offsetX,
                offsetY: tempStartPoint.offsetY,
              },
              path: this.tempPath,
              width: this.sourceImage.width,
              height: this.sourceImage.height,
              length: this.tempPath.length,
            });
            const arr: any[] = [];
            let totalLength: any = 0;
            this.t["轨迹"]["裂纹"].forEach((item: any) => {
              arr.push({
                length: item["length"] + "px",
              });
              totalLength += item["length"];
            });
            const d: any = {
              is_labeled: true,
              裂纹总长度: totalLength,
              裂纹数量: arr.length,
              裂纹: arr,
            };
            this.t["舌形特征标注"]["裂纹参数"] = d;
            this.tempPath = [];
            this.startPoint = {};
            this.context.restore();
            this.draw();
            this.drawPath();
          });
        } else {
          // this.context.closePath();
          // this.context.stroke();
          this.tempPath = [];
          this.startPoint = {};
        }
        this.context.restore();
        break;
      case "宽宽比":
        if (this.picType === "origin") {
          const tempStartPoint = _.cloneDeep(this.startPoint);
          tempStartPoint.offsetX -= blackWidth;
          tempStartPoint.offsetY -= blackHeight;
          const tempEndPoint = _.cloneDeep(this.endPoint);
          tempEndPoint.offsetX -= blackWidth;
          tempEndPoint.offsetY -= blackHeight;
          this.t["轨迹"]["宽宽比"][this.kuankuanbiModel] = {
            startPoint: tempStartPoint,
            endPoint: tempEndPoint,
            width: this.sourceImage.width,
            height: this.sourceImage.height,
          };
          this.t["舌形特征标注"]["胖瘦参数"][
            this.kuankuanbiModel
          ] = this.calLineLength(tempStartPoint, tempEndPoint);
          this.t["舌形特征标注"]["胖瘦参数"]["is_labeled"] = true;
          this.startPoint = {};
          this.endPoint = {};
          this.drawPath();
          if (
            this.t["舌形特征标注"]["胖瘦参数"]["嘴角间距"] &&
            this.t["舌形特征标注"]["胖瘦参数"]["舌间距"]
          ) {
            this.t["舌形特征标注"]["胖瘦参数"]["宽宽比"] =
              this.t["舌形特征标注"]["胖瘦参数"]["嘴角间距"] /
              this.t["舌形特征标注"]["胖瘦参数"]["舌间距"];
            this.model = "";
            this.$emit("modelChange", "");
          }
        }

        break;
      case "放大镜":
        this.drawBlackBack().then(() => {
          this.draw();
          this.drawPath();
        });

        break;
    }
    this.startPoint.offsetX = 0;
    this.startPoint.offsetY = 0;
  }
  /**
   * @description 计算两点连线的线段长
   */
  private calLineLength(point1, point2) {
    const value1 = Math.pow(point2.offsetX - point1.offsetX, 2);
    const value2 = Math.pow(point2.offsetY - point1.offsetY, 2);
    return Math.pow(value1 + value2, 0.5);
  }
  /**
   * @description 计算当前绘制面积
   */
  private calDrawedArea() {
    const imgData = this.context.getImageData(
      this.sourceImage.x,
      this.sourceImage.y,
      this.sourceImage.width,
      this.sourceImage.height
    );
    const pixels = imgData.data;
    const transPixels: any[] = [];
    for (let i = 0; i < pixels.length; i += 4) {
      if (!(pixels[i] === 0 && pixels[i + 1] === 0 && pixels[i + 2] === 0)) {
        transPixels.push(pixels[i + 3]);
      }
    }
    const area = ((transPixels.length / (pixels.length / 4)) * 100).toFixed(2);
    return area;
  }
  /**
   * @description 局部舌色
   */
  private jubushese() {
    this.model = "局部舌色";
  }
  /**
   * @description 删除局部舌色
   */
  private deleteJubushese() {
    delete this.t["轨迹"]["局部舌色"];
    this.drawBlackBack().then(() => {
      this.draw();
      this.drawPath();
    });
  }
  /**
   * @description 局部苔色
   */
  private jubutaise() {
    this.model = "局部苔色";
  }
  /**
   * @description 删除局部苔色
   */
  private deleteJubutaise() {
    delete this.t["轨迹"]["局部苔色"];
    this.drawBlackBack().then(() => {
      this.draw();
      this.drawPath();
    });
  }
  /**
   * @description 舌上红点
   */
  private sheshanghongdian() {
    this.model = "舌上红点";
  }
  /**
   * @description 删除舌上红点
   */
  private deleteSheshanghongdian() {
    delete this.t["轨迹"]["舌上红点"];
    this.drawBlackBack().then(() => {
      this.draw();
      this.drawPath();
    });
  }
  /**
   * @description 瘀斑
   */
  private yuban() {
    this.model = "瘀斑";
  }
  /**
   * @description 删除某个瘀斑
   */
  private deleteYuban(index) {
    this.t["轨迹"]["瘀斑"].splice(index, 1);
    this.drawBlackBack().then(() => {
      this.draw();
      this.drawPath();
    });
    const arr: any[] = [];
    let totalArea: any = 0;
    this.t["轨迹"]["瘀斑"].forEach((item: any) => {
      arr.push({
        area: item["area"].toFixed(2) + "px²",
      });
      totalArea += item["area"];
    });
    const d: any = {
      is_labeled: true,
      瘀斑面积占比: (totalArea / this.cuttedArea).toFixed(2),
      瘀斑数量: arr.length,
      瘀斑: arr,
    };
    if (arr.length === 0) {
      d.is_labeled = false;
      delete d["瘀斑面积占比"];
    }
    this.t["舌形特征标注"]["瘀斑参数"] = d;
  }
  /**
   * @description 齿痕
   */
  private chihen() {
    this.model = "齿痕";
  }
  /**
   * @description 删除某个齿痕
   */
  private deleteChihen(index) {
    this.t["轨迹"]["齿痕"].splice(index, 1);
    this.drawBlackBack().then(() => {
      this.draw();
      this.drawPath();
    });
    const arr: any[] = [];
    let totalArea: any = 0;
    this.t["轨迹"]["齿痕"].forEach((item: any) => {
      arr.push({
        area: item["area"].toFixed(2) + "px²",
      });
      totalArea += item["area"];
    });
    const d: any = {
      is_labeled: true,
      齿痕面积占比: (totalArea / this.cuttedArea).toFixed(2),
      齿痕数量: arr.length,
      齿痕: arr,
    };
    if (arr.length === 0) {
      d.is_labeled = false;
      delete d["齿痕面积占比"];
    }
    this.t["舌形特征标注"]["齿痕参数"] = d;
  }
  /**
   * @description 裂纹
   */
  private liewen() {
    this.model = "裂纹";
  }
  /**
   * @description 删除某个裂纹
   */
  private deleteLiewen(index) {
    this.t["轨迹"]["裂纹"].splice(index, 1);
    this.drawBlackBack().then(() => {
      this.draw();
      this.drawPath();
    });
    const arr: any[] = [];
    let totalLength: any = 0;
    this.t["轨迹"]["裂纹"].forEach((item: any) => {
      arr.push({
        length: item["length"] + "px",
      });
      totalLength += item["length"];
    });
    const d: any = {
      is_labeled: true,
      裂纹总长度: totalLength,
      裂纹数量: arr.length,
      裂纹: arr,
    };
    if (arr.length === 0) {
      d.is_labeled = false;
      delete d["裂纹总长度"];
    }
    this.t["舌形特征标注"]["裂纹参数"] = d;
  }
  /**
   * @description 宽宽比
   */
  private kuankuanbi() {
    this.model = "宽宽比";
  }
  /**
   * @description 删除宽宽比某条线
   */
  private deleteKuankuanbi(part) {
    this.t["轨迹"]["宽宽比"][part] = {};
    this.drawBlackBack().then(() => {
      this.draw();
      this.drawPath();
    });
  }
  /**
   * @description 移动
   */
  private yidong() {
    this.model = "移动";
  }
  /**
   * @description 缩放
   */
  private suofang() {
    this.model = "缩放";
  }
  /**
   * @description 放大镜
   */
  private fangdajing() {
    this.model = "放大镜";
  }
  /**
   * @description 旋转
   */
  private xuanzhuan() {
    this.model = "旋转";
  }
  /**
   * @description 截屏
   */
  private jieping() {
    this.model = "截屏";
    html2canvas(this.canvasWrap).then((canvas: HTMLCanvasElement) => {
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const i = document.createElement("a");
      i.download = "舌象图片";
      i.href = imgData;
      document.body.appendChild(i);
      i.click();
      i.remove();
    });
  }
  /**
   * @description 还原
   */
  private huanyuan() {
    this.model = "还原";
    this.sourceImage.rotateAngel = 0;
    this.sourceImage.moveX = 0;
    this.sourceImage.moveY = 0;
    this.sourceImage.scaleX = 1;
    this.sourceImage.scaleY = 1;
    this.t["轨迹"] = {};
    this.initCanvas();
  }
  /**
   * @description 后续绘制
   */
  private draw() {
    this.context.drawImage(
      this.sourceImage.imgObj,
      this.sourceImage.x,
      this.sourceImage.y,
      this.sourceImage.width,
      this.sourceImage.height
    );
    // this.drawPath();
  }
  /**
   * @description 画轨迹
   */
  private drawPath() {
    if (this.t["轨迹"] && this.picType === "origin") {
      if (this.t["轨迹"]["局部舌色"]) {
        const d = this.t["轨迹"]["局部舌色"];
        const dw = this.sourceImage.width / d.width;
        const dh = this.sourceImage.height / d.height;
        const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
        const blackHeight = (this.canvas.height - this.sourceImage.height) / 2;
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(
          d.startPoint.offsetX * dw + blackWidth,
          d.startPoint.offsetY * dh + blackHeight
        );
        this.context.strokeStyle = this.sheseColor;
        d.path.forEach((path: any) => {
          this.context.lineTo(
            path.offsetX * dw + blackWidth,
            path.offsetY * dh + blackHeight
          );
          this.context.stroke();
        });
        this.context.closePath();
        this.context.stroke();
        this.context.restore();
      }
      if (this.t["轨迹"]["局部苔色"]) {
        const d = this.t["轨迹"]["局部苔色"];
        const dw = this.sourceImage.width / d.width;
        const dh = this.sourceImage.height / d.height;
        const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
        const blackHeight = (this.canvas.height - this.sourceImage.height) / 2;
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(
          d.startPoint.offsetX * dw + blackWidth,
          d.startPoint.offsetY * dh + blackHeight
        );
        this.context.strokeStyle = this.taiseColor;
        d.path.forEach((path: any) => {
          this.context.lineTo(
            path.offsetX * dw + blackWidth,
            path.offsetY * dh + blackHeight
          );
          this.context.stroke();
        });
        this.context.closePath();
        this.context.stroke();
        this.context.restore();
      }
      if (this.t["轨迹"]["舌上红点"]) {
        const d = this.t["轨迹"]["舌上红点"];
        const dw = this.sourceImage.width / d.width;
        const dh = this.sourceImage.height / d.height;
        const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
        const blackHeight = (this.canvas.height - this.sourceImage.height) / 2;
        this.context.save();
        this.context.beginPath();
        this.context.moveTo(
          d.startPoint.offsetX * dw + blackWidth,
          d.startPoint.offsetY * dh + blackHeight
        );
        this.context.strokeStyle = this.hongdianColor;
        d.path.forEach((path: any) => {
          this.context.lineTo(
            path.offsetX * dw + blackWidth,
            path.offsetY * dh + blackHeight
          );
          this.context.stroke();
        });
        this.context.closePath();
        this.context.stroke();
        this.context.restore();
      }
      if (this.t["轨迹"]["瘀斑"] && Array.isArray(this.t["轨迹"]["瘀斑"])) {
        this.t["轨迹"]["瘀斑"].forEach((yuban: any) => {
          const d = yuban;
          const dw = this.sourceImage.width / d.width;
          const dh = this.sourceImage.height / d.height;
          const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
          const blackHeight =
            (this.canvas.height - this.sourceImage.height) / 2;
          this.context.save();
          this.context.beginPath();
          this.context.moveTo(
            d.startPoint.offsetX * dw + blackWidth,
            d.startPoint.offsetY * dh + blackHeight
          );
          this.context.strokeStyle = this.yubanColor;
          d.path.forEach((path: any) => {
            this.context.lineTo(
              path.offsetX * dw + blackWidth,
              path.offsetY * dh + blackHeight
            );
            this.context.stroke();
          });
          this.context.closePath();
          this.context.stroke();
          this.context.restore();
        });
      }
      if (this.t["轨迹"]["齿痕"] && Array.isArray(this.t["轨迹"]["齿痕"])) {
        this.t["轨迹"]["齿痕"].forEach((yuban: any) => {
          const d = yuban;
          const dw = this.sourceImage.width / d.width;
          const dh = this.sourceImage.height / d.height;
          const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
          const blackHeight =
            (this.canvas.height - this.sourceImage.height) / 2;
          this.context.save();
          this.context.beginPath();
          this.context.moveTo(
            d.startPoint.offsetX * dw + blackWidth,
            d.startPoint.offsetY * dh + blackHeight
          );
          this.context.strokeStyle = this.chihenColor;
          d.path.forEach((path: any) => {
            this.context.lineTo(
              path.offsetX * dw + blackWidth,
              path.offsetY * dh + blackHeight
            );
            this.context.stroke();
          });
          this.context.closePath();
          this.context.stroke();
          this.context.restore();
        });
      }
      if (this.t["轨迹"]["裂纹"] && Array.isArray(this.t["轨迹"]["裂纹"])) {
        this.t["轨迹"]["裂纹"].forEach((yuban: any) => {
          const d = yuban;
          const dw = this.sourceImage.width / d.width;
          const dh = this.sourceImage.height / d.height;
          const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
          const blackHeight =
            (this.canvas.height - this.sourceImage.height) / 2;
          this.context.save();
          this.context.beginPath();
          this.context.moveTo(
            d.startPoint.offsetX * dw + blackWidth,
            d.startPoint.offsetY * dh + blackHeight
          );
          this.context.strokeStyle = this.liewenColor;
          d.path.forEach((path: any) => {
            this.context.lineTo(
              path.offsetX * dw + blackWidth,
              path.offsetY * dh + blackHeight
            );
            this.context.stroke();
          });
          // this.context.closePath();
          // this.context.stroke();
          this.context.restore();
        });
      }
      if (this.t["轨迹"]["宽宽比"]) {
        if (
          this.t["轨迹"]["宽宽比"]["嘴角间距"] &&
          this.t["轨迹"]["宽宽比"]["嘴角间距"]["startPoint"] &&
          this.t["轨迹"]["宽宽比"]["嘴角间距"]["endPoint"]
        ) {
          const d = this.t["轨迹"]["宽宽比"]["嘴角间距"];
          const dw = this.sourceImage.width / d.width;
          const dh = this.sourceImage.height / d.height;
          const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
          const blackHeight =
            (this.canvas.height - this.sourceImage.height) / 2;
          this.context.save();
          this.context.beginPath();
          this.context.strokeStyle = this.kuankuanbiColor;
          this.context.moveTo(
            d.startPoint.offsetX * dw + blackWidth,
            d.startPoint.offsetY * dh + blackHeight
          );
          this.context.lineTo(
            d.endPoint.offsetX * dw + blackWidth,
            d.endPoint.offsetY * dh + blackHeight
          );
          this.context.closePath();
          this.context.stroke();
          this.context.restore();
        }
        if (
          this.t["轨迹"]["宽宽比"]["舌间距"] &&
          this.t["轨迹"]["宽宽比"]["舌间距"]["startPoint"] &&
          this.t["轨迹"]["宽宽比"]["舌间距"]["endPoint"]
        ) {
          const d = this.t["轨迹"]["宽宽比"]["舌间距"];
          const dw = this.sourceImage.width / d.width;
          const dh = this.sourceImage.height / d.height;
          const blackWidth = (this.canvas.width - this.sourceImage.width) / 2;
          const blackHeight =
            (this.canvas.height - this.sourceImage.height) / 2;
          this.context.save();
          this.context.beginPath();
          this.context.strokeStyle = this.kuankuanbiColor;
          this.context.moveTo(
            d.startPoint.offsetX * dw + blackWidth,
            d.startPoint.offsetY * dh + blackHeight
          );
          this.context.lineTo(
            d.endPoint.offsetX * dw + blackWidth,
            d.endPoint.offsetY * dh + blackHeight
          );
          this.context.closePath();
          this.context.stroke();
          this.context.restore();
        }
      }
    }
  }
  /**
   * @description 绘制黑色背景
   */
  private drawBlackBack() {
    this.context.save();
    return new Promise((resolve) => {
      this.context.fillRect(
        -this.canvas.width * 2,
        -this.canvas.height * 2,
        this.canvas.width * 5,
        this.canvas.height * 5
      );
      this.context.restore();
      resolve();
    });
  }
  private test(key) {
    alert(key);
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.calCuttedTongueArea();
    this.initCanvas();
    window.onresize = () => {
      this.initCanvas();
    };
  }
}
